import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';

const AuthorIdsSection = ({ onUpdate, boostInput = false }) => {
  const [currentAuthorIds, setCurrentAuthorIds] = useState('');
  const [boost, setBoost] = useState(1);
  const [authorFieldType, setAuthorFieldType] = useState('user_id');

  const handleAuthorAction = (actionType) => {
    if (!currentAuthorIds.trim()) return;
    
    const authorIdsArray = currentAuthorIds.split(',').map(id => id.trim()).filter(id => id);
    if (authorIdsArray.length === 0) return;
    
    const updateData = {
      action: actionType,
      filter: 'terms',
      field: authorFieldType,
      value: authorIdsArray
    };
    
    // Add boost value if boostInput is enabled
    if (boostInput) {
      updateData.boost = boost;
    }
    
    onUpdate(updateData);
    setCurrentAuthorIds(''); // Reset after adding
  };

  return (
    <Box>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Author Field Type</InputLabel>
        <Select
          value={authorFieldType}
          onChange={(e) => setAuthorFieldType(e.target.value)}
          label="Author Field Type"
        >
          <MenuItem value="user_id">User ID</MenuItem>
          <MenuItem value="user_name">User Name</MenuItem>
        </Select>
      </FormControl>
      
      <TextField
        label={authorFieldType === 'user_id' ? 'Author IDs' : 'Author Names'}
        value={currentAuthorIds}
        onChange={(e) => setCurrentAuthorIds(e.target.value)}
        placeholder={authorFieldType === 'user_id' ? "Enter comma-separated author IDs" : "Enter comma-separated author names"}
        helperText={authorFieldType === 'user_id' ? "e.g., 123, 456, 789" : "e.g., john, alice, bob"}
        fullWidth
        sx={{ mb: 2 }}
      />
      
      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleAuthorAction('include')}
          disabled={!currentAuthorIds.trim()}
        >
          <AddIcon />
        </Button>
        
        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleAuthorAction('boost')}
            disabled={!currentAuthorIds.trim()}
          >
            <TrendingUpIcon />
          </Button>
        )}
        
        <Button
          variant="contained"
          color="error"
          onClick={() => handleAuthorAction('exclude')}
          disabled={!currentAuthorIds.trim()}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default AuthorIdsSection;

